import { observer } from 'mobx-react';
import { ExperiencesResource, Toggle } from '../../Types';
import ToggleButton from '../../../../../../../ToggleButton';
import { T } from '../../../../../../../../Translations';
import { equals } from 'ramda';
import { when } from '@execonline-inc/maybe-adapter';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import { assertNever } from '../../../../../../../../Decoders';

interface Props {
  experiences: ExperiencesResource;
  toggle: Toggle;
  setToggle: (arg: Toggle) => void;
}

function UnLicensedToggle({ experiences, toggle, setToggle }: Props) {
  const toggleValue = (arg: Toggle) => {
    switch (arg) {
      case 'show-licensed':
        return false;
      case 'show-licensed-and-unlicensed':
        return true;
    }
  };

  const handleToggle = () => {
    switch (toggle) {
      case 'show-licensed':
        setToggle('show-licensed-and-unlicensed');
        break;
      case 'show-licensed-and-unlicensed':
        setToggle('show-licensed');
        break;
      default:
        assertNever(toggle);
    }
  };

  return when(equals(experiences.payload.showUnlicensedToggle), 'show')
    .map(() => (
      <div className="flex items-center">
        <ToggleButton
          handleOnClick={handleToggle}
          value={toggleValue(toggle)}
          onOffIcon="show"
          ariaLabel="Show Unlicensed Programs"
        />
        <h6 className="text-xs ml-3">
          <T kind="Show Unlicensed Programs" />
        </h6>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(UnLicensedToggle);
